import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import combineStyles from '../../utils/combineStyles';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';

import ProgressBar from '../Global/ProgressBar';

const styles = theme => ({
  totalCount: {
    fontWeight: '400 !important'
  },
  rootBase: {
    backgroundColor: '#FFFFFF',
    borderRadius: '2px',
    boxShadow:
      '0 1px 1px 0 rgba(12,31,44,0.12), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(12,31,44,0.2)',
    padding: theme.spacing.unit * 3,
    width: '100%'
  }
});

export const SummaryCard = ({
  classes,
  totalCount,
  message,
  ProgressBarProps
}) => (
  <div className={classes.rootBase}>
    <p className={classnames(classes.headline4, classes.totalCount)}>
      {totalCount}
    </p>
    <p className={classes.headline7}>{message}</p>
    <ProgressBar {...ProgressBarProps} />
  </div>
);

SummaryCard.propTypes = {
  totalCount: PropTypes.number.isRequired,
  message: PropTypes.string.isRequired,
  ProgressBarProps: PropTypes.shape({
    color: PropTypes.string,
    totalValue: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    resourceType: PropTypes.string.isRequired
  }).isRequired
};

export default withStyles(
  combineStyles(TypographyStyles, LayoutStyles, styles)
)(SummaryCard);
